import { IKeyValuePair } from '@caslink/common-client';
import * as _ from 'lodash';

import {
    IControlInput, IDeviceInformation, IDeviceItemGrouping, IDeviceItemVisitor,
    IDeviceNode, IDynamicControlsSharedState, IDynamicInputList
} from '../shared/models/device';

import { DeviceService } from '../shared/services/device.service';
import { RelationshipTypes } from '../shared/models/models';

// This class will visit any node that is a DynamicElementList.  This is an input were the user can
// specify a number of inputs and child inputs will be displayed based on the selected number.
export class DynamicListInputVisitor implements IDeviceItemVisitor {
    public service: DeviceService;
    public currentGrouping: IDeviceItemGrouping;

    private sharedState: IDynamicControlsSharedState;

    public init(
        rootNode: IDeviceNode,
        device: IDeviceInformation,
        sharedState: IDynamicControlsSharedState
    ) {
        this.sharedState = sharedState;
    }

    public canVisit(owningObject: IDeviceNode, propName: string, propValue: IDeviceNode): boolean {
        return propValue.fieldRelationship && propValue.fieldRelationship.relationshipType === RelationshipTypes.DynamicElementList;
    }

    public visit(owningObject: IDeviceNode, propName: string, propValue: IDeviceNode): IDeviceItemGrouping {
        let dynamicList: IDynamicInputList =  propValue as IDynamicInputList;

        dynamicList.$ignoreChildren = true;
        dynamicList.$fieldName = this.sharedState.nextId();
        dynamicList.$categories = [];
        dynamicList.$sections = [];
        dynamicList.$controlInputs = [];

        this.setListItems(owningObject, dynamicList);
        return null;
    }

    private setListItems(owningObject: IDeviceNode, elementList: IDynamicInputList) {

        // Finds the other property on the node corresponding to the set of
        // related inputs.
        let itemListName = elementList.fieldRelationship.relatedFieldId;

        let itemList = owningObject[itemListName];
        delete itemList.elementType;

        if (itemList.items) {

            // For each related input, create a new section and  invoke the input-visitor
            // with the section as the current grouping.

            _.forEach(itemList.items, (item: IKeyValuePair<string, IControlInput>) => {
                let controlInput = item.value;

                delete controlInput.elementType;
                controlInput.$ignoreChildren = true;

                var section: IDeviceItemGrouping = {
                    displayText: controlInput.displayText,
                    isVisible: controlInput.isVisible,
                    $categories: [],
                    $controlInputs: [],
                    $sections: []
                };

                elementList.$sections.push(section);

                this.service.visitDeviceStructure(controlInput, section);
            });
        }
    }
}
